import React from 'react'
import '../styles/footer.css'

/**
 * Footer del sitio — modo claro y oscuro via clase .dark en <body>
 */
const Footer = () => (
    <footer className="app-footer">
        <div className="app-footer__inner">

            {/* Columna izquierda — marca */}
            <div className="app-footer__brand">
                <span className="app-footer__name">Hospitales MAC</span>
                <span className="app-footer__tagline">Médica Avanzada Contigo</span>
            </div>

            {/* Centro — links */}
            <div className="app-footer__links">
                <a href="https://hospitalesmac.com/privacidad.php"
                   target="_blank" rel="noreferrer"
                   className="app-footer__link">
                    Aviso de Privacidad
                </a>
                <span className="app-footer__sep">·</span>
                <a href="https://hospitalesmac.com"
                   target="_blank" rel="noreferrer"
                   className="app-footer__link">
                    hospitalesmac.com
                </a>
            </div>

            {/* Columna derecha — contacto */}
            <div className="app-footer__contact">
                <span>contacto@hospitalesmac.com</span>
                <span className="app-footer__copy">© {new Date().getFullYear()} Derechos reservados</span>
            </div>

        </div>
    </footer>
)

export default Footer